module.exports = __webpack_public_path__ + "img/2024-code.47773c79.png";